import API from "@/utils/API";
import MapJs from "@/utils/Map.js";

class Site {
  constructor(app) {
    this.app = app;
  }

  /** --- SITE --- */
  async setSite(sit_id) {
    if (sit_id && this.$root.global?.site?.sit_id !== sit_id) {
      this.$root.global.site = API.getFirstData(
        await API.get("site", {
          SitId: sit_id,
        })
      );

      this.$root.pageLoad = false;

      if (
        !this.$root.isPilotLogin &&
        this.$root.mainMapReady
        // && this.$route?.meta?.fullscreenMap
      ) {
        this.addModels3DSite();
        this.$root.global.site.pinPoint = MapJs.add_pin_Site(
          this.$root.global.site
        );
        MapJs.ZoomIfIsReload();
      }
    }
    else {
      if (this.$root.global.site.pinPoint !== undefined) {
        MapJs.getViewer().entities.remove(this.$root.global.site.pinPoint);
      }
      this.$root.global.site = undefined;
      MapJs?.model3d?.clear();
    }

    this.$root.setCustomArea();

    if (
      !this.$root.isPilotLogin &&
      !this.$root.isPopup &&
      this.$root?.global?.reloadDevices
    ) {
      this.$root.global.reloadDevices();
    }
  }

  async addModels3DSite() {
    // si le site contient des modèles 3D, on les charge ici
    // 1- on récupére les infos des différents modeles du site

    if (MapJs?.model3d?.getListModel === undefined) {
      setTimeout(() => {
        this.addModels3DSite();
      }, 2000);
      return;
    }

    this.$root.global.site.sit_mod3d = MapJs.model3d.getListModel();
    // on ajoute dans la 3D les modeles
    MapJs.model3d.refresh();
  }

  async getGarageId() {
    let idGarage = false;
    let sites = await API.get("site");
    sites.forEach((site) => {
      if (site.sit_name == ENV.DEVICE_SITE_GARAGE) {
        idGarage = site.sit_id;
      }
    });

    if (idGarage === false) {
      let responseSite = await API.post(`site`, {
        cmp_id: $root.user.getData().cmp_id,
        sit_name: ENV.DEVICE_SITE_GARAGE,
        sit_mod3d: "",
        sit_lng: 0,
        sit_lat: 0,
      });

      if (responseSite?.sit_id === undefined) {
        throw new Error(responseSite.Error);
      }

      idGarage = responseSite.sit_id;
    }

    return idGarage;
  }

  async setCustomArea() {
    if (this.$root.isPilotLogin) return;

    setTimeout(async () => {
      this.unloadCustomArea();

      if (
        this.$root.global.site == undefined ||
        this.$route.name == "Site_Zone2VolCreate" ||
        this.$route.name == "Site_Zone2VolEdit"
      ) {
        return;
      }

      if (MapJs.getViewer()?.entities == undefined) {
        setTimeout(
          () => {
            this.setCustomArea()
          }, 2000);
        return;
      }

      let customAreas = await API.get("custarea", {
        sit_id: this.$root.global.site.sit_id,
      });

      if (customAreas?.length != undefined && customAreas.length > 0) {
        customAreas.forEach(async (customArea) => {
          if (customArea.cua_active) {
            this.$root.global.customArea = await MapJs.newAddCustomArea(
              customArea.cua_geom,
              customArea.cua_id,
              customArea.cua_name
            );
          }
        });
      }
    }, 3000);
  }

  unloadCustomArea() {
    if (
      this.$root?.global?.customArea?.collection?._entities?._array ===
      undefined
    )
      return;
    this.$root.global.customArea.collection._entities._array.forEach((el) => {
      MapJs.getViewer().entities.remove(el);
    });
    this.$root.global.customArea = undefined;
  }
}

export default Site;
